import {
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaString,
    validateName,
    validateCellphoneNumber,
    validateEmail,
} from '@om/validation';
import {
    SET_LIMIT_INDEMNITY_VALUE,
    SET_SPECIALTIES_VALUE,
    SET_EMAIL_VALUE,
    SET_FIRST_NAME_VALUE,
    SET_SURNAME_VALUE,
    SET_PHONE_NUMBER_VALUE,
    setLimitIndemnityValid,
    setSpecialtiesValid,
    setFirstNameValid,
    setSurnameValid,
    setEmailValid,
    setPhoneNumberValid,
} from '../../../actions/doctorsPi/quote';
import { validationIsEqual } from '../status';

let prevValidationAction = null;

export const quoteValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case SET_FIRST_NAME_VALUE:
                error = validateName(action.value, { required: true, min: 1, subject: 'First name' });
                return setFirstNameValid(error);
            case SET_SURNAME_VALUE:
                error = validateName(action.value, { required: true, min: 1, subject: 'Sur  name' });
                return setSurnameValid(error);
            case SET_EMAIL_VALUE:
                error = validateEmail(action.value, { required: true, min: 1, subject: 'Email' });
                return setEmailValid(error);
            case SET_PHONE_NUMBER_VALUE:
                error = validateCellphoneNumber(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Phone number',
                    countryCode: 'ke',
                });
                return setPhoneNumberValid(error);
            case SET_LIMIT_INDEMNITY_VALUE:
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value, {
                    subject: 'Limit Indmenity value',
                    required: true,
                });
                return setLimitIndemnityValid(error);

            case SET_SPECIALTIES_VALUE:
                error = validateAlphaString(action.value, {
                    subject: 'Specialization',
                    required: true,
                });
                return setSpecialtiesValid(error);
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
